import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../../baseComponents/AppsStyleDecider'
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import BuyInvoiceStatusBar, { BuyInvoiceStatusBarNew, CreateInvoiceStatusBarProps } from '../../../BuyInvoiceStatusBar'
import BuyInvoiceCreateStepButtons, { BuyInvoiceCreateStepButtonsNew } from '../BuyInvoiceCreateStepButtons'

type BuyInvoiceCreateStepHeaderProps = & CreateInvoiceStatusBarProps & OrderStepButtonsBaseComponentProps

const BuyInvoiceCreateStepHeaderDecider: React.FC<BuyInvoiceCreateStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={BuyInvoiceCreateStepHeaderDefault} NewComponent={BuyInvoiceCreateStepHeaderNew} {...rest} />
    )
}

const BuyInvoiceCreateStepHeaderDefault: React.FC<BuyInvoiceCreateStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <BuyInvoiceStatusBar {...rest} />
            <BuyInvoiceCreateStepButtons {...rest} />
        </div>
    )
}

const BuyInvoiceCreateStepHeaderNew: React.FC<BuyInvoiceCreateStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <BuyInvoiceStatusBarNew {...rest} />
            <BuyInvoiceCreateStepButtonsNew {...rest} />
        </Fragment>
    )
}

export default BuyInvoiceCreateStepHeaderDecider